<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const user = computed(() => store.getters.getUserDetails);
const isAuthenticated = computed(() => store.getters.isAuthenticated);
const userDetails = computed(() => {
    const attributes = user.value;
    
    if (!Array.isArray(attributes)) {
        return null; 
    }
    
    const roleAttr = attributes.find(attr => attr.Name === 'custom:role');
    const nameAttr = attributes.find(attr => attr.Name === 'name');
    console.log(attributes.find(attr => attr.Name === 'name'))
    
    return roleAttr && nameAttr ? {role:roleAttr.Value,name:nameAttr.Value} : null;
});

const handleSignOut = () => {
    store.dispatch('logout');
};
</script>

<template>
    <ul class="nav user-menu">
        <li class="nav-item nav-searchinputs">
            <div class="top-nav-search">
                
            </div>
        </li>
        <li>
           <div class="location-switcher" v-if="hasMultipleLocations">
                <select v-model="currentLocationId" @change="updateLocation">
                    <option v-for="loc in locations" :key="loc.id" :value="loc.id">
                    {{ loc.name }}
                    </option>
                </select>
            </div>
            <div v-else-if="currentLocationName" class="location-display">
            Location: {{ currentLocationName }}
            </div> 
        </li>
        
        <li class="nav-item nav-item-box">
            <a href="javascript:void(0);" id="btnFullscreen" @click="initFullScreen">
                <vue-feather type="maximize"></vue-feather>
            </a>
        </li>
        <template v-if="isAuthenticated">
            <li class="nav-item dropdown has-arrow main-drop">
                <a
                    href="javascript:void(0);"
                    class="dropdown-toggle nav-link userset"
                    data-bs-toggle="dropdown"
                >
                    <span class="user-info">
                        <span class="user-letter">
                            <img src="../assets/img/profiles/avator1.jpg" alt="" class="img-fluid" />
                        </span>
                        <span class="user-detail">
                            <span class="user-name">{{userDetails?.name}}</span>
                            <span class="user-role">{{userDetails?.role}}</span>
                        </span>
                    </span>
                </a>
                <div class="dropdown-menu menu-drop-user">
                    <div class="profilename">
                        <div class="profileset">
                            <span class="user-img"
                                ><img src="../assets/img/profiles/avator1.jpg" alt="" />
                                <span class="status online"></span
                            ></span>
                            <div class="profilesets">
                                <h6>{{userDetails?.name}}</h6>
                                <h5>{{userDetails?.role}}</h5>
                            </div>
                        </div>
                        <hr class="m-0" />
                        <hr class="m-0" />
                        <router-link class="dropdown-item logout pb-0" @click="handleSignOut" to="/signin"
                            ><img
                                src="../assets/img/icons/log-out.svg"
                                class="me-2"
                                alt="img"
                                
                            />Logout</router-link
                        >
                    </div>
                </div>
            </li>
        </template>
    </ul>
    </template>
<script>
import headernotification from "../assets/json/headernotification.json";
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            headernotification: headernotification
        };
    },
    computed: {
        ...mapGetters(['getLocations', 'hasMultipleLocations', 'getCurrentLocationId', 'getCurrentLocationName']),
        locations() { return this.getLocations; },
        currentLocationId: {
            get() {
                return this.getCurrentLocationId;
            },
            set(id) {
                const loc = this.locations.find(l => l.id === id);
                if (loc) {
                this.$store.dispatch('setCurrentLocation', { id: loc.id, name: loc.name });
                }
            }
        },
        currentLocationName() { return this.getCurrentLocationName; }
    },
    methods: {
        updateLocation(event) {
        const id = event.target.value;
        const loc = this.locations.find(l => l.id === id);
        if (loc) {
            this.$store.dispatch('setCurrentLocation', { id: loc.id, name: loc.name });
        }
        }
    },
    methods: {
        initFullScreen() {
            document.body.classList.toggle("fullscreen-enable");
            if (
                !document.fullscreenElement &&
                /* alternative standard method */
                !document.mozFullScreenElement &&
                !document.webkitFullscreenElement
            ) {
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        },
    }
};
</script>
<style scoped>
.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: #f8f9fa;
  border-bottom: 1px solid #ddd;
}
.location-switcher select {
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 4px;
}
.location-display {
  font-weight: 600;
  color: #333;
}
</style>